import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "external-search-request-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NForm = _resolveComponent("NForm")!
  const _component_NButton = _resolveComponent("NButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NForm, {
      ref: "form",
      layout: _ctx.formLayout,
      model: _ctx.module.item
    }, null, 8, ["layout", "model"]),
    _createVNode(_component_NButton, {
      class: "external-search-request-form__done",
      onClick: _ctx.save
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('external_search.done')), 1)
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}